/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiNotificationsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор push-уведомления")
    })

/**
 * @description Уведомление удалено
 */
export const deleteApiNotificationsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiNotificationsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiNotificationsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiNotificationsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Push уведомление не найдено
 */
export const deleteApiNotificationsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiNotificationsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiNotificationsIdMutationResponseSchema = z.lazy(() => deleteApiNotificationsId200Schema)